<div class="tw-min-w-[200px] xl:tw-min-w-[260px] tw-h-full">
  <mh-data-rate-widget
    [loading]="loading"
    [title]="'followup.summary.data-rate.title' | translate"
    tooltipTitle="followup.summary.data-rate.tooltip_interchain_answers_rate"
    [totalPercentage]="answersRate"
    [qualification]="qualificationAnswersRate"
    [items]="itemsAnswersRate"
    [showIndicators]="true"
    [hideStatusIndicators]="true"
    [hideQualification]="true"
    [blurWhatsapp]="false"
    [productId]="productId"
    [report]="reportAnswersRate"
    [slugReportButton]="reportAnswersRateSlug"
    [dates]="currentDates"
    [tooltipGraph]="tooltipGraph"
    [leftFooterText]="leftTextAnswerRate | translate"
    [leftFooterTooltip]="leftTextAnswerRateTooltip | translate"
    [second_button_text]="secondButtonText | translate | uppercase"
    [secondButtonTooltip]="secondButtonTooltip | translate"
    [heigth]="heigth"
    [blockSuperAdminActions]="true"
    [isSuperAdmin]="isSuperAdmin"
    (onViewMore)="onViewMore()">
  </mh-data-rate-widget>
</div>
